interface EnvConfig {
  NODE_ENV?: string;
  API_PATH?: string;
  ADMIN_API_PATH?: string;
  MEDIA_API_PATH?: string;
  PUBLIC_URL?: string;
  APP_DSN_SENTRY?: string;
  HOME_URL?: string;
  DISABLE_SURVEY_MODULE?: string;
  DISABLE_SECURITY_MODULE?: string;
  DISABLE_OPERATIONS_MODULE?: string;
  DISABLE_ASSETS_MODULE?: string;
  DISABLE_PLANNING_MODULE?: string;
  GOOGLE_API_KEY?: string;
  EMOJI_ENABLED?: string;
  [key: string]: any;
}

export function getEnv(): EnvConfig {
  if (typeof window === 'undefined') {
    return process?.env;
  }

  const envs = (window as any)?.ENV ?? process?.env;
  return {
    NODE_ENV: envs?.NODE_ENV,
    API_PATH: envs?.API_PATH,
    ADMIN_API_PATH: envs?.ADMIN_API_PATH,
    MEDIA_API_PATH: envs?.MEDIA_API_PATH,
    PUBLIC_URL: envs?.PUBLIC_URL,
    APP_DSN_SENTRY: envs?.APP_DSN_SENTRY,
    HOME_URL: envs?.HOME_URL,
    DISABLE_SURVEY_MODULE: envs?.DISABLE_SURVEY_MODULE,
    DISABLE_SECURITY_MODULE: envs?.DISABLE_SECURITY_MODULE,
    DISABLE_OPERATIONS_MODULE: envs?.DISABLE_OPERATIONS_MODULE,
    DISABLE_ASSETS_MODULE: envs?.DISABLE_ASSETS_MODULE,
    DDISABLE_PLANNING_MODULE: envs?.DISABLE_PLANNING_MODULE,
    GOOGLE_API_KEY: envs?.GOOGLE_API_KEY,
    EMOJI_ENABLED: envs?.EMOJI_ENABLED,
  };
}
